import { apiExportManager } from 'services/iclinic/api';
import { AuditEvent } from './types';

export function sendAuditReportRequest(data: AuditEvent) {
  return apiExportManager.post(`/export/audit_event/`, data);
}
